import { Box } from "@mui/system";

import { useEffect, useRef } from "react";
function SecondSection() {

 const sectionRef = useRef(null);

 useEffect(() => {
   
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "section_scroll",
            section_name: "SecondSection",
            timestamp: new Date().toISOString(),
          });
          console.log("GTM Event Sent: SecondSection Scroll");
        }
      },
      { threshold: 0.4 } // triggers when 40% visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);




  return (
    <Box
 ref={sectionRef}
 sx={{
  position: "relative",
        bgcolor: "#fff",
        py: { xs: 4, sm: "12", md: 12 },
        overflow: "hidden",
        backgroundImage: "url(/img1/frame1.png)",
        backgroundRepeat: "no-repeat",
        // backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundSize: { xs: "contain", sm: "cover", md: "cover", lg: "cover" },
        width: "100%",
      }}
    >

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Box
          component="img"
          src="/img1/Group.png"
          alt="Download on the App Store"
          sx={{
            width: "100%",
            maxWidth: { xs: 200, sm: 300, md: 400 },
            maxHeight: 600,
            objectFit: "contain",
            cursor: "pointer",
          }}


           onClick={() => {
            // ✅ GTM click event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "image_click",
              section_name: "SecondSection",
              image_name: "Group.png",
              timestamp: new Date().toISOString(),
            });
           
          }}
        />
      </Box>
    </Box>
  );
}

export default SecondSection;
